import { createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'
import EventEmitter, {
  SHOW_POPUP_CONFIRMATION,
} from '../../../helpers/EventEmitter'
import { handleExport } from '../../../helpers/export'
import UserManagementService from '../../store/services/UserManagementService'

export const getSubscriptionPlanDetails = createAsyncThunk(
  'userManagement/getSubscriptionPlanDetails',
  async (params, { rejectWithValue }) => {
    try {
      const response = await UserManagementService.getSubscriptionPlanDetails(
        params,
      )
      if (response.success) return response.data
      return rejectWithValue({ loading: false })
    } catch (error) {
      if (axios.isCancel(error)) {
        return rejectWithValue({ loading: true })
      }
      return rejectWithValue({ loading: false })
    }
  },
)

export const getSubscriptionPlans = createAsyncThunk(
  'userManagement/getSubscriptionPlans',
  async (params, { rejectWithValue }) => {
    try {
      const response = await UserManagementService.getSubscriptionPlans(params)
      if (response.success) return response.data
      return rejectWithValue({ loading: false })
    } catch (error) {
      if (axios.isCancel(error)) {
        return rejectWithValue({ loading: true })
      }
      return rejectWithValue({ loading: false })
    }
  },
)

export const getPricingPackages = createAsyncThunk(
  'userManagement/getPricingPackages',
  async (params, { rejectWithValue }) => {
    try {
      const response = await UserManagementService.getPricingPackages(params)
      if (response.success) return response.data
      return rejectWithValue({ loading: false })
    } catch (error) {
      if (axios.isCancel(error)) {
        return rejectWithValue({ loading: true })
      }
      return rejectWithValue({ loading: false })
    }
  },
)

export const getUserSetting = createAsyncThunk(
  'userManagement/getUserSetting',
  async (params, { rejectWithValue }) => {
    try {
      const response = await UserManagementService.getUserSetting(params)
      if (response.success) return response.data
      return rejectWithValue({ loading: false })
    } catch (error) {
      if (axios.isCancel(error)) {
        return rejectWithValue({ loading: true })
      }
      return rejectWithValue({ loading: false })
    }
  },
)

export const postActiveTrial = createAsyncThunk(
  'userManagement/postActiveTrial',
  async (params) => {
    const response = await UserManagementService.postActiveTrial(params)
    return response
  },
)

export const postDeactiveTrial = createAsyncThunk(
  'userManagement/postDeactiveTrial',
  async (params) => {
    const response = await UserManagementService.postDeactiveTrial(params)

    if (response.success) {
      EventEmitter.dispatch(
        SHOW_POPUP_CONFIRMATION,
        'subscriptionPayment.DEACTIVE_TRIAL_MESS',
      )
    }

    return response
  },
)

export const getSampleQuotations = createAsyncThunk(
  'userManagement/getSampleQuotations',
  async (params, { rejectWithValue }) => {
    try {
      const response = await UserManagementService.getSampleQuotations(params)
      handleExport(response.data, response.filename)
    } catch (error) {
      return rejectWithValue({ loading: false })
    }
  },
)

export const postQuotations = createAsyncThunk(
  'userManagement/postQuotations',
  async (params, { rejectWithValue }) => {
    try {
      const response = await UserManagementService.postQuotations(params)
      handleExport(response.data, response.filename)
    } catch (error) {
      return rejectWithValue({ loading: false })
    }
  },
)

export const getSampleContract = createAsyncThunk(
  'userManagement/getSampleContract',
  async (params, { rejectWithValue }) => {
    try {
      const response = await UserManagementService.getSampleContract(params)
      handleExport(response.data, response.filename)
    } catch (error) {
      return rejectWithValue({ loading: false })
    }
  },
)

export const postRequestContract = createAsyncThunk(
  'userManagement/postRequestContract',
  async (params, { rejectWithValue }) => {
    try {
      const res = await UserManagementService.postRequest(params)
      if (res?.data?.success) {
        EventEmitter.dispatch(
          SHOW_POPUP_CONFIRMATION,
          'internationalPreview.CONFIRM_MESSAGE',
        )
      }
      return rejectWithValue('Error')
    } catch (error) {
      return rejectWithValue(error)
    }
  },
)

export const getSubscriptionPricings = createAsyncThunk(
  'userManagement/getSubscriptionPricings',
  async (params, { rejectWithValue }) => {
    try {
      const response = await UserManagementService.getSubscriptionPricings(
        params,
      )
      if (response.success) return response.data
      return rejectWithValue({ loading: false })
    } catch (error) {
      if (axios.isCancel(error)) {
        return rejectWithValue({ loading: true })
      }
      return rejectWithValue({ loading: false })
    }
  },
)

export const postSubscriptionAndPackageOrders = createAsyncThunk(
  'userManagement/postSubscriptionAndPackageOrders',
  async (params) => {
    const response =
      await UserManagementService.postSubscriptionAndPackageOrders(params)
    return response
  },
)

export const postSubscriptionAndPackageNewTransaction = createAsyncThunk(
  'userManagement/postSubscriptionAndPackageNewTransaction',
  async (params) => {
    const response =
      await UserManagementService.postSubscriptionAndPackageNewTransaction(
        params,
      )
    return response
  },
)

export const getIsAvailableToAddNewSubscription = createAsyncThunk(
  'userManagement/getIsAvailableToAddNewSubscription',
  async (params) => {
    try {
      const response =
        await UserManagementService.getIsAvailableToAddNewSubscription(params)
      return response.data
    } catch (error) {}
  },
)
